<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
			<el-button type="primary" size="mini" @click="openModel('gys')" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table :data="gysList" style="width: 100%" size="mini"	row-key="id" :tree-props="{ children: 'child', hasChildren: 'hasChildren' }"  @current-change="handleCurrentChange">
				<el-table-column width="80" align="center">
					<template slot="header" slot-scope="scope">编号</template>
					<template slot-scope="scope">{{scope.row.id}}</template>
				</el-table-column>
				<el-table-column width="160">
					<template slot="header" slot-scope="scope">供应商名称</template>
					<template slot-scope="scope">{{scope.row.name}}</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">联系人</template>
					<template slot-scope="scope">{{scope.row.lxr}}</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">联系电话</template>
					<template slot-scope="scope">{{scope.row.lxdh}}</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">采购员</template>
					<template slot-scope="scope">
						<el-button type="success" size="mini" plain>{{scope.row.cgy.name}}</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">联系电话</template>
					<template slot-scope="scope">
						<el-button type="success" plain size="mini">{{scope.row.bm.name}}</el-button>
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">创建时间</template>
					<template slot-scope="scope">{{scope.row.create_time}}</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">排序</template>
					<template slot-scope="scope">{{scope.row.id}}</template>
				</el-table-column>
				<el-table-column align="center" fixed="right" width="290">
					<template slot="header" slot-scope="scope">操作</template>
					<template slot-scope="scope">
						<!-- <el-button type="primary" size="mini" @click="openModel('gys',scope.row)">查看</el-button> -->
						<el-button type="primary" size="mini" @click="openModel('gys',scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" 	:total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="类别详情" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<div style="width: 50%;">
					<el-form v-if="preUrl ==='gys' " ref="form" :model="form.gys" label-width="80px">
						<el-form-item label="供应商名">
							<el-input v-model="form.gys.name" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="电子邮件">
							<el-input v-model="form.gys.dzyj" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="地区">
							<el-input v-model="form.gys.dq" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="开户银行">
							<el-input v-model="form.gys.khyh" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="备注">
							<el-input v-model="form.gys.desc" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="采购员">
							<el-select v-model="valueb" placeholder="请选择" size="mini">
							    <el-option
							      v-for="item in cgy"
							      :key="item.id"
							      :label="item.name"
							      :value="item.id">
							    </el-option>
							  </el-select>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 50%;">
					<el-form v-if="preUrl ==='gys' " ref="form" :model="form.gys" label-width="80px">
						<el-form-item label="联系人">
							<el-input v-model="form.gys.lxr" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="联系电话">
							<el-input v-model="form.gys.lxdh" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="详细地址">
							<el-input v-model="form.gys.xxdz" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="银行账号">
							<el-input v-model="form.gys.yhzh" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="部门">
							<el-select v-model="valuec" placeholder="请选择" size="mini">
							    <el-option
							      v-for="item in bumen"
							      :key="item.id"
							      :label="item.name"
							      :value="item.id">
							    </el-option>
							  </el-select>
						</el-form-item>
					</el-form>
				</div>
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				gys: {
				},
			},
			createModel: false,
			valueb:'',
			cgy:[],
			valuec: '',
			bumen:[],
			dialogType: "gys",
			preUrl: "gys", //api
			dialogId: 0,
			gysList:[]
		};
		
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`
		},
		// 处理列表结果
		getListResult(e) {
			this.gysList = e.list
			this.axios.get('/admin/bumen/1',{
				token: true
			}).then(res => {
				this.bumen = res.data.data.list
			})
			this.axios.get('/admin/managers/list',{
				token: true
			}).then(res => {
				this.cgy = res.data.data
			})
			
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'gys':
					if (!item) {
						this.form.gys = {
							id:'',
							name: "",
							lxr: "",
							lxdh: "",
							dzyj: "",
							dq: "",
							xxdz: "",
							khyh: "",
							yhzh: "",
							desc:"",
							cgy:"",
							bm:"",
						}
						this.dialogId = 0
					} else {
						this.valueb = item.cgy
						this.valuec = item.bm
						this.form.gys = {
							name: item.name,
							lxr: item.lxr,
							lxdh: item.lxdh,
							dzyj: item.dzyj,
							dq: item.dq,
							xxdz: item.xxdz,
							khyh: item.khyh,
							yhzh: item.yhzh,
							desc:item.desc,
							cgy:item.cgy,
							bm:item.bm,
						}
						this.dialogId = item.id
					}
					break;
			}
			// 打开dialog
			this.createModel = true;
		},
		submit() {
			let f = this.form.gys
			let e = {
				name: f.name,
				lxr: f.lxr,
				lxdh: f.lxdh,
				dzyj: f.dzyj,
				dq: f.dq,
				xxdz: f.xxdz,
				khyh: f.khyh,
				yhzh: f.yhzh,
				desc:f.desc,
				cgy:this.valueb,
				bm:this.valuec,
				cjr:this.user.id
			}
			this.addOrEdit(e, this.dialogId);
			this.createModel = false;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style></style>
